<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12" md="10" offset-md="1">
        <h2>Add people or charities you want to leave an inheritance to</h2>
        <br />
        <ul>
          <li>
            You do not need to add your spouse/partner or children again under
            the heirs section
          </li>
          <li>
            You will indicate what you give your heirs in the
            <b><em>Specific Donations</em></b> step
          </li>
        </ul>

        <div class="list-section">
          <h2>Heirs</h2>
          <PeopleList
            :people="relations.heirs"
            :testator="testator"
            relation="HEIR"
          />
        </div>

        <div class="list-section">
          <h2>Charities</h2>
          <CharitiesList :charities="testator.charities" />
        </div>

        <div v-if="showTrusts" class="list-section">
          <h2>Trusts</h2>
          <TrustsList :trusts="testator.trusts" />
        </div>

        <div class="button-container">
          <DefaultButton
            @defaultButtonClicked="redirectBack"
            :callout="'left'"
            :small="true"
          />
          <GradientButton
            :title="'Next'"
            :small="true"
            :callout="'right'"
            @gradientButtonClicked="redirectToNext"
          />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import PeopleList from './PeopleList.vue';
  import CharitiesList from './CharitiesList.vue';
  import TrustsList from './TrustsList.vue';

  export default {
    name: 'OptionalInheritors',
    components: {
      PeopleList,
      CharitiesList,
      TrustsList,
    },
    props: {
      testator: { type: Object, required: true },
      relations: { type: Object, required: true },
    },
    computed: {
      showTrusts() {
        return this.testator.willCountry != 'GB';
      },
    },
    methods: {
      redirectToNext() {
        this.$router.push({ name: 'OverviewPage', hash: '#your-people' });
      },
      redirectBack() {
        this.$router.push('executor');
      },
    },
  };
</script>

<style scoped lang="scss">
  .list-section {
    margin-top: 35px;
  }
  .button-container {
    gap: 20px;
  }
</style>
